import axios from 'axios';
import router from '@/router';

axios.defaults.baseURL = 'https://api.faramaham.com/api/v1'




//*************** Run on request sended to server ********************/
axios.interceptors.request.use(
    async config => {
        if (config.url !== '/auth/login') {
            config.headers['Authorization'] = 'Bearer' + ' ' + localStorage.getItem('accessToken') || '';
        }
        return config;
    },
    err => {
        return err.response
    }
)
//*************** Run on response get from server ********************/
axios.interceptors.response.use(
    async res => {
        return res;
    },
    async err => {
        if (err.response.status != 401) {
            return err;
        }
        if (err.response.status == 401) {
            localStorage.clear();
            router.push('/login');
        }
    })



export default axios;
